import { useEffect, useMemo, useState } from "react";
import { NavLink, Link } from "react-router-dom";
import "./Profile.css";
import { httpAdmin } from "../../Apis/commonApis";
import { useDispatch, useSelector } from "react-redux";
import { ShowSwal } from "../../utils/alertSwal";
import { getCareSiteListing } from "../../redux-toolkit/reducer/caresiteDataReducer";
import { useForm, Controller } from "react-hook-form";
import Select from "react-select";
import { getTaxesAndCurrency } from "../../redux-toolkit/reducer/websitePlan";
import { Modal } from "react-bootstrap";
import { labelValInitialState } from "../../utils/CommonFunctions";

export default function Billing() {
  const dispatch = useDispatch();

  let { currentCareSiteData } = useSelector(
    (state) => state.caresiteDataReducer
  );
  const { taxesAddedCountryList, taxesAddedStateList } = useSelector(
    (state) => state.websitePlans
  );

  const {
    control,
    register,
    handleSubmit,
    formState: { errors },
    setValue,
    watch,
    reset,
  } = useForm();

  const [invoiceHistory, setInvoiceHistory] = useState([]);
  const [openAddressModal, setOpenAddressModal] = useState(false);

  useEffect(() => {
    dispatch(getCareSiteListing());
    dispatch(getTaxesAndCurrency());
  }, []);

  useEffect(() => {
    if (currentCareSiteData) {
      const defaultAddress = currentCareSiteData?.billingAddress;
      setValue("billingAddress", defaultAddress ?? "");

      setValue("billingCity", currentCareSiteData?.billingCity ?? "");
      setValue(
        "billingPostalCode",
        currentCareSiteData?.billingPostalCode ?? ""
      );
      const invoices = [];
      currentCareSiteData.invoices?.forEach((elem) => {
        invoices.push(elem?.invoicesDetails ?? elem);
      });
      setInvoiceHistory(invoices);
    }
  }, [currentCareSiteData]);

  const findBillingCountryObj = useMemo(() => {
    return taxesAddedCountryList?.find(
      (cItem) => cItem.label === currentCareSiteData?.billingCountry
    );
  }, [currentCareSiteData]);

  const findBillingStateObj = useMemo(() => {
    return taxesAddedStateList?.find(
      (cItem) => cItem.label === currentCareSiteData?.billingState
    );
  }, [currentCareSiteData]);

  const changeBillAddress = async (postdata) => {
    let finaldata = {
      ...postdata,
      adminId: currentCareSiteData?.adminId,
      careHomeId: currentCareSiteData?._id,
      subAdminId: currentCareSiteData?._id,
    };
    handleCloseModal();
    let result = await httpAdmin(
      "editCarehomeProfile",
      "post",
      finaldata,
      null
    );
    ShowSwal(result.status, result.message);
    if (result.status) {
      dispatch(getCareSiteListing());
    }
  };

  const handleCloseModal = () => {
    setOpenAddressModal(false);
  };

  return (
    <div className="mt-3 profileBox">
      <div className="col-md-12">
        <div className="row profileB">
          <div className="col-9">
            <ul>
              <li>
                <p>
                  <span className="themeColor">Billing Method:</span>
                  {currentCareSiteData?.paymentThrough === "gocardless"
                    ? "Direct Debit"
                    : "Credit Card"}
                </p>
                <p>
                  <NavLink
                    to={{
                      pathname: "/profile/update-billing-method",
                      state: { ownerId: currentCareSiteData?.adminId },
                    }}
                  >
                    Update
                  </NavLink>
                </p>
              </li>
              <li>
                <p>
                  <span className="themeColor">Billing Address:</span>{" "}
                  {getCombinedBillingAddress(currentCareSiteData)}
                </p>
                {/* currentCareSiteData?.paymentThrough != "gocardless" && */}
                {
                  <a
                    style={{ color: "#2d9cdb" }}
                    href="#"
                    onClick={() => setOpenAddressModal(true)}
                  >
                    Update
                  </a>
                }
              </li>
            </ul>
            <h5 className="themeColor mt-3">Invoice History</h5>

            <ul className="billingHistory">
              {invoiceHistory?.map((item, i) => {
                return (
                  <li key={i}>
                    <p>
                      {new Date(item?.invoiceDate).toLocaleDateString("en-US")}{" "}
                      — {item?.symbol ?? "£"} {item.amountDue ?? item.total}
                    </p>
                    <p>
                      {/* <NavLink to={item.invoiceLink} target="_blank" download={item.invoiceLink}>
                        Invoice
                      </NavLink> */}

                      <a href={item.invoiceLink} target="_blank">
                        Invoice
                      </a>
                    </p>
                  </li>
                );
              })}
            </ul>

            {/* <button className="btn">See More</button> */}

            {invoiceHistory?.length === 0 && <p>No data to show!!</p>}
          </div>
        </div>
      </div>

      {openAddressModal && (
        <Modal show={openAddressModal} onHide={handleCloseModal}>
          <Modal.Body>
            <div
              tabIndex="-1"
              aria-labelledby="exampleModalLabel"
              aria-hidden="true"
            >
              <form onSubmit={handleSubmit(changeBillAddress)}>
                <div className="modal-content">
                  <div className="modal-header">
                    <h5 className="modal-title" id="exampleModalLabel">
                      Update Billing Address
                    </h5>
                    <button
                      type="button"
                      className="btn-close"
                      data-bs-dismiss="modal"
                      aria-label="Close"
                      onClick={handleCloseModal}
                    ></button>
                  </div>
                  <div className="modal-body">
                    <div className="row">
                      <div className="col-md-12 mb-3">
                        <label htmlFor="cc-name">Billing Address</label>
                        <input
                          type="text"
                          className="form-control"
                          name="billingAddress"
                          {...register("billingAddress", {
                            required: true,
                          })}
                        />
                        {errors?.billingAddress?.type === "required" && (
                          <p className="error_style error_bottom mt-1">
                            This field is required
                          </p>
                        )}
                      </div>
                      <div className="col-md-6 mb-3">
                        {/* <label htmlFor="cc-name">City</label> */}
                        <input
                          type="text"
                          className="form-control"
                          placeholder="Enter City"
                          name="billingCity"
                          {...register("billingCity", {
                            required: true,
                          })}
                        />
                        {errors?.billingCity?.type === "required" && (
                          <p className="error_style error_bottom mt-1">
                            This field is required
                          </p>
                        )}
                      </div>
                      <div className="col-md-6 mb-3">
                        <Select
                          className="select_Box_border"
                          placeholder="Country"
                          options={[]}
                          isDisabled={true}
                          value={findBillingCountryObj || labelValInitialState}
                        />
                      </div>
                      {findBillingCountryObj?.label === "United States" && (
                        <div className="col-md-6 mb-3">
                          <Select
                            className="select_Box_border"
                            placeholder="State"
                            isDisabled={true}
                            options={[]}
                            value={findBillingStateObj || labelValInitialState}
                          />
                        </div>
                      )}
                      <div className="col-md-6 mb-3">
                        {/* <label htmlFor="cc-name">Postal Code</label> */}
                        <input
                          type="text"
                          className="form-control"
                          placeholder="Postal code"
                          name="billingPostalCode"
                          {...register("billingPostalCode", {
                            required: true,
                          })}
                        />
                        {errors?.billingPostalCode?.type === "required" && (
                          <p className="error_style error_bottom mt-1">
                            This field is required
                          </p>
                        )}
                      </div>
                    </div>
                  </div>
                  <div className="modal-footer">
                    <button type="submit" className="btn btn-success">
                      Save
                    </button>
                  </div>
                </div>
              </form>
            </div>
          </Modal.Body>
        </Modal>
      )}
    </div>
  );
}

export function getCombinedBillingAddress(data) {
  let combinedAddress = data?.billingAddress ?? "";

  const city = data?.billingCity ?? "";
  const postalCode = data?.billingPostalCode ?? "";
  const country = data?.billingCountry ?? "";
  const state = data?.billingState ?? "";

  // Append only if not already included
  if (city) {
    combinedAddress += (combinedAddress ? ", " : "") + city;
  }

  if (postalCode) {
    combinedAddress += (combinedAddress ? ", " : "") + postalCode;
  }

  if (state) {
    combinedAddress += (combinedAddress ? ", " : "") + state;
  }

  if (country) {
    combinedAddress += (combinedAddress ? ", " : "") + country;
  }

  return combinedAddress;
}
